<template>
  <div>
    <PreviewDocumentDialog
      :opened.sync="previewDialogOpened"
      :preview-type="previewType"
      :preview-rotation="previewRotation"
      :preview-loaded="previewLoaded"
      :document-preview-data="documentPreviewData"
      :selected-document-link="selectedDocumentLink"
      :hide-move-button="true"
      :hide-edit-button="true"
      :hide-rename-button="true"
    />

    <v-layout
      v-for="(wetSignature, index) in currentForm.wetSignatures"
      :key="index"
      column
    >
      <v-layout
        align-center
        justify-space-between
        class="uploaded-item"
        @click="previewDocument(wetSignature.signedDocumentPath)"
      >
        <v-layout align-center>
          <v-icon class="material-icons-outlined grey--text">
            insert_drive_file
          </v-icon>
          <span class="ml-1 body-1">
            {{ getDocumentName(wetSignature.signedDocumentPath) }}
          </span>
        </v-layout>

        <v-layout align-center class="button-containers">
          <v-tooltip bottom v-if="!hideDownloadButton">
            <v-btn
              slot="activator"
              icon
              flat
              color="primary"
              @click.stop.prevent="
                downloadDocumentByPath(wetSignature.signedDocumentPath)
              "
              class="ml-1"
            >
              <v-icon class="material-icons-outlined">download</v-icon>
            </v-btn>
            <span>Download</span>
          </v-tooltip>

          <v-tooltip bottom v-if="!hideDeleteButton">
            <v-btn
              slot="activator"
              icon
              flat
              color="error"
              @click.stop.prevent="
                removeSignedForm(wetSignature.signedDocumentPath)
              "
              class="ml-1"
            >
              <v-icon class="material-icons-outlined">delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </v-layout>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import PreviewDocumentDialog from '@/components/dialogs/PreviewDocumentDialog';
import { supportedExtensionsForPreview } from '@/constants/variables';
import API from '@/api';
import axios from 'axios';
import get from 'lodash/get';

export default {
  components: {
    PreviewDocumentDialog,
  },

  props: {
    currentCompany: {
      type: Object,
    },

    taxReturn: {
      type: Object,
    },

    currentForm: {
      type: Object,
    },

    hideDownloadButton: {
      type: Boolean,
    },

    hideDeleteButton: {
      type: Boolean,
    },
  },

  data() {
    return {
      // For previewing document
      previewDialogOpened: false,
      previewRotation: 0,
      previewType: null,
      previewLoaded: false,
      documentPreviewData: null,
      selectedDocumentLink: null,
      supportedExtensionsForPreview,
    };
  },

  methods: {
    async removeSignedForm(documentPath) {
      this.currentForm.wetSignatures = this.currentForm.wetSignatures.filter(
        signature => signature.signedDocumentPath !== documentPath,
      );

      const response = await axios.patch(`/tax_returns/${this.taxReturn.id}`, {
        company_id: this.currentCompany.id,
        e_sign_forms: this.taxReturn.e_sign_forms,
      });

      this.$emit('tax-return-updated', response.data);
    },

    getDocumentName(path) {
      return path.split('/')[path.split('/').length - 1];
    },

    async previewDocument(documentLink) {
      this.previewType = '';
      this.previewLoaded = false;
      this.documentPreviewData = '';
      this.selectedDocumentLink = documentLink;
      this.previewRotation = 0;

      this.previewType = this.endsWithAny(
        this.supportedExtensionsForPreview,
        documentLink,
      );

      if (this.previewType) {
        if (this.previewType === 'pdf') {
          this.currentPage = 1;
          this.pdfLoaded = false;
        }

        this.previewDialogOpened = true;

        try {
          const response = await API.integration.downloadDocument({
            companyId: this.currentCompany.id,
            link: this.currentCompany.upload_link.concat('/', documentLink),
          });

          if (response.data.document) {
            this.documentPreviewData = response.data.document.data.link;
          }
        } catch (e) {
          console.log(e);
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem downloading the document.',
            errorToSend: e,
          });
        } finally {
          this.previewLoaded = true;
        }
      } else {
        this.downloadDocumentByLink(
          this.documentPreviewData,
          this.getDocumentName(documentLink),
        );
      }
    },

    endsWithAny(suffixes, string) {
      return suffixes.find(function(suffix) {
        return string.toLowerCase().endsWith(suffix);
      });
    },

    async downloadDocumentByPath(documentPath) {
      try {
        const response = await API.integration.downloadDocument({
          companyId: this.currentCompany.id,
          link: this.currentCompany.upload_link.concat('/', documentPath),
        });

        const url = response.data.document.data.link;
        await this.downloadDocumentByLink(
          url,
          this.getDocumentName(documentPath),
        );
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem downloading the document.',
          errorToSend: e,
        });
      } finally {
        this.previewLoaded = true;
      }
    },

    async downloadDocumentByLink(url, name) {
      let response = await this.$http.get(url, { responseType: 'arraybuffer' });
      let blob = new Blob([response.data], {
        type: get(response.headers, 'content-type'),
      });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name;
      link.click();
    },
  },
};
</script>

<style lang="postcss" scoped>
.uploaded-item {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0px 16px;
  margin-top: 6px;
  cursor: pointer;
  background-color: #fff;
  height: 40px;

  &:hover {
    background-color: #eee;
  }
}

.button-containers {
  flex-grow: 0;
}
</style>
